var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgQueueIcon = function SvgQueueIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "07.-Minc-Admin",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "New-Menu",
    transform: "translate(-480.000000, -362.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Component-/-Navigation-Bar-/-Clinic",
    transform: "translate(460.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clinic-List",
    transform: "translate(0.000000, 289.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 2,
    transform: "translate(0.000000, 60.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Text-Fill",
    transform: "translate(20.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_Left",
    transform: "translate(0.000000, 13.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9999836,19 C18.9953975,20.1053568 18.1000963,21 16.9941413,21 L7.00585866,21 C5.90090142,21 5.00461875,20.1026811 5.00001779,19 L18.9999836,19 Z M19.9999659,16 C19.9953929,17.1053568 19.1026487,18 18.005922,18 L5.99404259,18 C4.89558466,18 4.0045739,17.1026811 4,16 L19.9999659,16 Z M19.0049107,3 C20.1067681,3 21,3.90195036 21,5.0085302 L21,12.9914698 C21,14.1007504 20.1073772,15 19.0049107,15 L4.99508929,15 C3.8932319,15 3,14.0980496 3,12.9914698 L3,5.0085302 C3,3.8992496 3.8926228,3 4.99508929,3 L19.0049107,3 Z M13.9074751,6.35272082 L11.0974262,9.10496209 L10.0912989,8.12082007 C9.61335772,7.65332264 8.83762249,7.65332264 8.35845586,8.12082007 C7.88051471,8.58951621 7.88051471,9.3483005 8.35845586,9.81579793 L10.2322302,11.6486276 C10.7113969,12.1173237 11.4871321,12.1173237 11.9662987,11.6474289 L15.642769,8.04530125 C16.1194847,7.57660511 16.1194847,6.81782082 15.6403181,6.35032339 C15.1636024,5.88402468 14.3854162,5.88162725 13.9074751,6.35272082 Z",
    id: "ic_menu_contract",
    fill: "#FFFFFF"
  }))))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgQueueIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/queue-icon.56e24d9d.svg";
export { ForwardRef as ReactComponent };